<div style="font-size: 15px; font-weight: 500;">
  {{ title }}
  <mat-divider [ngStyle]="{ width: '90%' }" ngStyle.lt-lg="{ width: '100%' }"></mat-divider>
</div>

<mat-list
  class="file-list"
  [ngStyle]="{ width: '90%' }"
  ngStyle.lt-lg="{ width: '100%' }"
  ngStyle.lt-md="{ 'margin-top': '9px', 'margin-bottom': '15px' }"
>
  @for (file of taskItems; track file?.id ?? file) {
    <mat-list-item>
      <div
        matLine
        style="display: inline-block !important; width: 100%;"
        ngStyle.gt-sm="{ 'margin-bottom': '12px' }"
        ngStyle.lt-md="{ 'margin-bottom': '36px' }"
      >
        <!-- 1st layout -->
        @if (this.innerWidth > 961 && this.innerWidth < 1502) {
          <div
            fxLayout="row"
            fxLayout="column wrap"
            ngStyle.gt-sm="{ 'margin-top': '9px' }"
          >
            <div fxFlex="50%">
              <div [ngSwitch]="file.statusCode" style="float: left !important;">
                <div *ngSwitchCase="700000000">
                  <small style="font-size: 14px; font-weight: 400;">To Do</small>
                </div>
                <div *ngSwitchDefault>
                  <small style="font-size: 14px; font-weight: 400;">
                    {{ file.name }}
                  </small>
                </div>

                <div style="float: left !important;">
                  @if (file.statusCode === 700000000) {
                    <div style="font-size: 14px; font-weight: 400;">
                      {{ file.name }}
                    </div>
                  } @else {
                    <a
                      style="color: #29637C; font-size: 16px; font-weight: 400;"
                      [title]="file.payloadName"
                      href="javascript:void(0)"
                      (click)="onViewFileEvent(file.payload)"
                    >
                      {{ file.payloadName | Filename }}
                    </a>
                  }
                </div>
              </div>
            </div>

            <div fxFlex="30%">
              <div [ngSwitch]="file.statusCode">
                <div>
                  <small style="font-size: 14px; font-weight: 400;">Status</small>
                </div>

                <div *ngSwitchCase="700000000" style="font-size: 16px; font-weight: 400;">
                  Waiting for upload
                </div>

                <div *ngSwitchCase="700000002">

                
                  <span class="warn-text">Action required</span>
                  <span>
                    (
                    <a
                      style="color: #29637C; font-size: 14px;"
                      href="javascript:void(0)"
                      (click)="onClickShowReasonWhy(file.reasonWhy)"
                    >
                      read why
                    </a>
                    )
                  </span>
                </div>

                <div *ngSwitchDefault style="font-size: 14px; font-weight: 400;">
                  {{ file.statusCodeOptionSet }}
                </div>
              </div>
            </div>

            <div fxFlex="20%">
              @if (checkUploadAuthorization(file) === 1 || checkUploadAuthorization(file) === 2) {
                <div class="buttonAlignContainer">
                  @if (checkUploadAuthorization(file) === 1 && file.statusCode !== 700000001) {
                    <div
                      style="color: #707070; text-transform: uppercase; height: 36px; padding-top: 12px; font-size: 14px; float: right;"
                    >
                      SUBMITTED
                    </div>
                  }

                  @if (checkUploadAuthorization(file) === 1 && file.statusCode === 700000001) {
                    <div
                      style="color: #707070; text-transform: uppercase; height: 36px; padding-top: 12px; font-size: 14px; float: right;"
                    >
                      APPROVED
                    </div>
                  }

                  @if (checkUploadAuthorization(file) === 2) {
                    <div
                      style="color: #707070; text-transform: uppercase; height: 36px; padding-top: 12px; font-size: 14px; float: right;"
                    >
                      READ-ONLY
                    </div>
                  }

                  @if (file.ebbModifiedByTypeOptionSet && file.ebbModifiedDate) {
                    <button
                      matTooltip="{{ file.ebbModifiedByTypeOptionSet }} Update, Date: {{ file.ebbModifiedDate | date:'MM/dd/yyyy':'PST' }}"
                      mat-icon-button
                      aria-label="Upload information"
                      color="primary"
                      style="text-transform: uppercase; margin-right: 15px; height: 24px; width: 24px;"
                      ngStyle.gt-sm="{ 'margin-top': '6px' }"
                    >
                      <mat-icon style="font-size: 24px; margin-top: -24px;">info</mat-icon>
                    </button>
                  }
                </div>
              } @else {
                <div
                  [ngSwitch]="file.statusCode"
                  [ngStyle]="{ float: 'right' }"
                  [ngStyle.lt-sm]="{ float: 'left' }"
                >
                  <div *ngSwitchCase="700000001" class="buttonAlignContainer">
                    <div
                      style="color: #707070; font-size: 14px; text-transform: uppercase;"
                      ngStyle.gt-sm="{ 'margin-top': '14px' }"
                    >
                      NO ACTION REQUIRED
                    </div>
                  </div>

                  <div *ngSwitchCase="700000002" class="buttonAlignContainer">
                    <button
                      mat-stroked-button
                      color="primary"
                      style="text-transform: uppercase; margin-right: 9px;"
                      ngStyle.gt-sm="{ 'margin-top': '6px' }"
                      (click)="onUploadFileEvent(file.payload, file.id, file.name, false, file.noteText)"
                    >
                      REPLACE
                    </button>

                    @if (application.stageCode == 700000000 || application.stageCode == 700000001) {
                      <button
                        mat-stroked-button
                        color="primary"
                        style="text-transform: uppercase; margin-right: 9px;"
                        ngStyle.gt-sm="{ 'margin-top': '6px' }"
                        (click)="onDeleteFileEvent(file.id, file.payload, file.payloadName)"
                      >
                        DELETE
                      </button>
                    }

                    @if (file.ebbModifiedByTypeOptionSet && file.ebbModifiedDate) {
                      <button
                        matTooltip="{{ file.ebbModifiedByTypeOptionSet }} Update, Date: {{ file.ebbModifiedDate | date:'MM/dd/yyyy':'PST' }}"
                        mat-icon-button
                        aria-label="Upload information"
                        color="primary"
                        style="text-transform: uppercase; margin-right:15px; height: 24px; width: 24px;"
                        ngStyle.gt-sm="{ 'margin-top': '6px' }"
                      >
                        <mat-icon style="font-size: 24px; margin-top: -24px;">info</mat-icon>
                      </button>
                    }
                  </div>

                  <div *ngSwitchCase="700000003" class="buttonAlignContainer">
                    <button
                      mat-stroked-button
                      color="primary"
                      style="text-transform: uppercase; margin-right: 9px;"
                      ngStyle.gt-sm="{ 'margin-top': '6px' }"
                      (click)="onUploadFileEvent(file.payload, file.id, file.name, false, file.noteText)"
                    >
                      REPLACE
                    </button>

                    @if (application.stageCode == 700000000 || application.stageCode == 700000001) {
                      <button
                        mat-stroked-button
                        color="primary"
                        style="text-transform: uppercase; margin-right: 9px;"
                        ngStyle.gt-sm="{ 'margin-top': '6px' }"
                        (click)="onDeleteFileEvent(file.id, file.payload, file.payloadName)"
                      >
                        DELETE
                      </button>
                    }

                    @if (file.ebbModifiedByTypeOptionSet && file.ebbModifiedDate) {
                      <button
                        matTooltip="{{ file.ebbModifiedByTypeOptionSet }} Update, Date: {{ file.ebbModifiedDate | date:'MM/dd/yyyy':'PST' }}"
                        mat-icon-button
                        aria-label="Upload information"
                        color="primary"
                        style="text-transform: uppercase; margin-right: 15px; height: 24px; width: 24px;"
                        ngStyle.gt-sm="{ 'margin-top': '6px' }"
                      >
                        <mat-icon style="font-size: 24px; margin-top: -24px;">info</mat-icon>
                      </button>
                    }
                  </div>

                  <div *ngSwitchDefault>
                    <button
                      mat-raised-button
                      color="primary"
                      style="text-transform: uppercase;"
                      ngStyle.gt-sm="{ 'margin-top': '6px' }"
                      (click)="onUploadFileEvent(null, file.id, file.name, false, null)"
                    >
                      UPLOAD
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- 2nd layout -->
        @if (this.innerWidth <= 961 || this.innerWidth >= 1502) {
          <div
            fxLayout="row"
            fxLayout.lt-md="column wrap"
            ngStyle.gt-sm="{ 'margin-top': '9px' }"
          >
            <div fxFlex="45%">
              <div [ngSwitch]="file.statusCode" style="float: left !important;">
                <div *ngSwitchCase="700000000">
                  <small style="font-size: 14px; font-weight: 400;">To Do</small>
                </div>
                <div *ngSwitchDefault>
                  <small style="font-size: 14px; font-weight: 400;">
                    {{ file.name }}
                  </small>
                </div>

                <div style="float: left !important;">
                  @if (file.statusCode === 700000000) {
                    <div style="font-size: 14px; font-weight: 400;">
                      {{ file.name }}
                    </div>
                  } @else {
                    <a
                      style="color: #29637C; font-size: 16px; font-weight: 400;"
                      [title]="file.payloadName"
                      href="javascript:void(0)"
                      (click)="onViewFileEvent(file.payload)"
                    >
                      {{ file.payloadName | Filename }}
                    </a>
                  }
                </div>
              </div>
            </div>

            <div fxFlex="32%">
              <div [ngSwitch]="file.statusCode">
                <div>
                  <small style="font-size: 14px; font-weight: 400;">Status</small>
                </div>

                <div *ngSwitchCase="700000000" style="font-size: 16px; font-weight: 400;">
                  Waiting for upload
                </div>

                <div *ngSwitchCase="700000002" style="font-size: 14px;">
                  <span class="warn-text">Action required</span>
                  <span>
                    (
                    <a
                      style="color: #29637C; font-size: 14px;"
                      href="javascript:void(0)"
                      (click)="onClickShowReasonWhy(file.reasonWhy)"
                    >
                      read why
                    </a>
                    )
                  </span>
                </div>

                <div *ngSwitchDefault style="font-size: 14px; font-weight: 400;">
                  {{ file.statusCodeOptionSet }}
                </div>
              </div>
            </div>

            <div fxFlex="23%">
              @if (checkUploadAuthorization(file) === 1 || checkUploadAuthorization(file) === 2) {
                <div class="buttonAlignContainer">
                  @if (checkUploadAuthorization(file) === 1 && file.statusCode !== 700000001) {
                    <div
                      style="color: #707070; text-transform: uppercase; height: 36px; padding-top: 12px; font-size: 14px; float: right;"
                    >
                      SUBMITTED
                    </div>
                  }

                  @if (checkUploadAuthorization(file) === 1 && file.statusCode === 700000001) {
                    <div
                      style="color: #707070; text-transform: uppercase; height: 36px; padding-top: 12px; font-size: 14px; float: right;"
                    >
                      APPROVED
                    </div>
                  }

                  @if (checkUploadAuthorization(file) === 2) {
                    <div
                      style="color: #707070; text-transform: uppercase; height: 36px; padding-top: 12px; font-size: 14px; float: right;"
                    >
                      READ-ONLY
                    </div>
                  }

                  @if (file.ebbModifiedByTypeOptionSet && file.ebbModifiedDate) {
                    <button
                      matTooltip="{{ file.ebbModifiedByTypeOptionSet }} Update, Date: {{ file.ebbModifiedDate | date:'MM/dd/yyyy':'PST' }}"
                      mat-icon-button
                      aria-label="Upload information"
                      color="primary"
                      style="text-transform: uppercase; margin-right: 15px; height: 24px; width: 24px;"
                      ngStyle.gt-sm="{ 'margin-top': '6px' }"
                    >
                      <mat-icon style="font-size: 24px; margin-top: -24px;">info</mat-icon>
                    </button>
                  }
                </div>
              } @else {
                <div
                  [ngSwitch]="file.statusCode"
                  [ngStyle]="{ float: 'right' }"
                  ngStyle.lt-md="{ 'margin-top': '12px' }"
                  [ngStyle.lt-sm]="{ float: 'left' }"
                >
                  <div *ngSwitchCase="700000001" class="buttonAlignContainer">
                    <div
                      style="color: #707070; font-size: 14px; text-transform: uppercase;"
                      ngStyle.gt-sm="{ 'margin-top': '14px' }"
                    >
                      NO ACTION REQUIRED
                    </div>
                  </div>

                  <div *ngSwitchCase="700000002" class="buttonAlignContainer">
                    <button
                      mat-stroked-button
                      color="primary"
                      style="text-transform: uppercase; margin-right: 9px;"
                      ngStyle.gt-sm="{ 'margin-top': '6px' }"
                      (click)="onUploadFileEvent(file.payload, file.id, file.name, false, file.noteText)"
                    >
                      REPLACE
                    </button>

                    @if (application.stageCode == 700000000 || application.stageCode == 700000001) {
                      <button
                        mat-stroked-button
                        color="primary"
                        style="text-transform: uppercase; margin-right: 9px;"
                        ngStyle.gt-sm="{ 'margin-top': '6px' }"
                        (click)="onDeleteFileEvent(file.id, file.payload, file.payloadName)"
                      >
                        DELETE
                      </button>
                    }

                    @if (file.ebbModifiedByTypeOptionSet && file.ebbModifiedDate) {
                      <button
                        matTooltip="{{ file.ebbModifiedByTypeOptionSet }} Update, Date: {{ file.ebbModifiedDate | date:'MM/dd/yyyy':'PST' }}"
                        mat-icon-button
                        aria-label="Upload information"
                        color="primary"
                        style="text-transform: uppercase; margin-right: 15px; height: 24px; width: 24px;"
                        ngStyle.gt-sm="{ 'margin-top': '6px' }"
                      >
                        <mat-icon style="font-size: 24px; margin-top: -24px;">info</mat-icon>
                      </button>
                    }
                  </div>

                  <div *ngSwitchCase="700000003" class="buttonAlignContainer">
                    <button
                      mat-stroked-button
                      color="primary"
                      style="text-transform: uppercase; margin-right: 9px;"
                      ngStyle.gt-sm="{ 'margin-top': '6px' }"
                      (click)="onUploadFileEvent(file.payload, file.id, file.name, false, file.noteText)"
                    >
                      REPLACE
                    </button>

                    @if (application.stageCode == 700000000 || application.stageCode == 700000001) {
                      <button
                        mat-stroked-button
                        color="primary"
                        style="text-transform: uppercase; margin-right: 9px;"
                        ngStyle.gt-sm="{ 'margin-top': '6px' }"
                        (click)="onDeleteFileEvent(file.id, file.payload, file.payloadName)"
                      >
                        DELETE
                      </button>
                    }

                    @if (file.ebbModifiedByTypeOptionSet && file.ebbModifiedDate) {
                      <button
                        matTooltip="{{ file.ebbModifiedByTypeOptionSet }} Update, Date: {{ file.ebbModifiedDate | date:'MM/dd/yyyy':'PST' }}"
                        mat-icon-button
                        aria-label="Upload information"
                        color="primary"
                        style="text-transform: uppercase; margin-right: 15px; height: 24px; width: 24px;"
                        ngStyle.gt-sm="{ 'margin-top': '6px' }"
                      >
                        <mat-icon style="font-size: 24px; margin-top: -24px;">info</mat-icon>
                      </button>
                    }
                  </div>

                  <div *ngSwitchDefault class="buttonAlignContainer">
                    <button
                      mat-raised-button
                      color="primary"
                      style="text-transform: uppercase;"
                      ngStyle.gt-sm="{ 'margin-top': '6px' }"
                      (click)="onUploadFileEvent(null, file.id, file.name, false, null)"
                    >
                      UPLOAD
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>

      
    </mat-list-item>
    <mat-divider fxShow></mat-divider>
  }

  @if (progressSaveIndicator) {
    <div style="margin-top: 12px;">
      <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
    </div>
  }
</mat-list>

@if ((showAddAnother && this.application.eventApplicationSubmitted !== true) || showAddAnotheronreject) {
  <div style="margin-top: 9px;">
    <button
      mat-stroked-button
      color="primary"
      style="text-transform: uppercase;"
      ngStyle.gt-sm="{ 'margin-top': '6px' }"
      (click)="onUploadFileEvent(null, '', '', true, null)"
    >
      <mat-icon>add</mat-icon>
      Add Another Receipt
    </button>
  </div>
}
